import angular from 'angular';
import 'ui-select';
import 'angular-bootstrap';
import './facetsServices';

const facetsControllers = angular.module('applicationModule.facetsControllers', [
    'applicationModule.facetsServices',
    'ui.bootstrap',
    'ui.select'
]);

facetsControllers.controller('FacetsController', ['$scope', '$rootScope', '$stateParams', '$state', '$filter', 'growl', 'NgTableParams', 'Facets', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $stateParams, $state, $filter, growl, NgTableParams, Facets, AppsoupAPI, Permissions) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('facets');
    $scope.writeAccess = true;
    $scope.application_id = $stateParams.application_id;
    $scope.parents = {};

    $scope.groupOptions = {
        'category': 'CATEGORIES',
        'dish_type': 'DISH_TYPE',
        'difficulty': 'DIFFICULTY',
        'recipe_time': 'PREPARATION_TIME',
        // 'allergens': 'ALLERGENS',
        'occasion': 'OCCASION',
        'ingredients': 'INGREDIENTS'
    };

    $scope.tableParams = new NgTableParams(AppsoupAPI.getOrderTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Facets.getList($scope.application_id, params._params).then(function (response) {
                const facets = response.facets;
                params.total(facets.total);
                params.count(facets.per_page);
                params.page(facets.current_page);
                $scope.parents = response.parents;
                return facets.data;
            }).finally(function () {
                $scope.isLoading = false;
                $scope.isFind = false;
            });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.removeFacet = function (id) {
        Facets.remove(id).then(function (response) {
            const data = response.data || response;
            if (data.success) {
                growl.success('MODULES.FACETS.SUCCESS.DELETED');
                $scope.tableParams.reload();
                //$scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.FACETS.ERROR.DELETED');
            }
        });
    };

    $scope.copyFacets = function (id) {
        Facets.copy(id).then(function (response) {
            const data = response.data || response;
            if (data.success) {
                growl.success('MODULES.FACETS.SUCCESS.COPIED');
                $state.go($state.current, {searchFacets: $stateParams.searchFacets}, {reload: true});
            } else if (data.error === 'ERROR.FACET_NOT_EXISTS') {
                growl.error('MODULES.FACETS.ERROR.FACET_NOT_EXISTS');
            } else {
                growl.error('MODULES.FACETS.ERROR.COPIED');
            }
        });
    };

    $scope.changeOrder = function ($event, key1, key2) {
        let data = $scope.tableParams.data;

        $event.stopImmediatePropagation();
        Facets.changeOrder({
            order_ids: [$scope.tableParams.data[key1].order, $scope.tableParams.data[key2].order],
            app_id: $scope.app_id
        })
            .then(function (response) {
                if (response.data.success) {
                    data = angular.changeOrderResponse(data, key1, key2);
                }
            });
        $scope.tableParams.data = data;
    };
}]);

facetsControllers.controller('FacetController', ['$scope', '$rootScope', '$stateParams', '$state', '$translate', '$filter', 'growl', 'NgTableParams', '$locale', 'Facets', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $stateParams, $state, $translate, $filter, growl, NgTableParams, $locale, Facets, AppsoupAPI, Permissions) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('facets');
    $scope.writeAccess = true;
    const appId = $stateParams.application_id;
    $scope.editMode = false;
    $scope.headerTitle = [];

    if (angular.isDefined($stateParams.facetId)) {
        $scope.editMode = true;
    }

    $scope.typeOptions = [{value: 'single', name: 'SINGLE'}, {value: 'multiple', name: 'MULTIPLE'}];
    $scope.groupOptions = [
        {value: 'category', name: 'CATEGORIES'},
        {value: 'dish_type', name: 'DISH_TYPE'},
        {value: 'difficulty', name: 'DIFFICULTY'},
        {value: 'recipe_time', name: 'PREPARATION_TIME'},
        // { value: 'allergens', name: 'ALLERGENS' },
        {value: 'occasion', name: 'OCCASION'},
        {value: 'ingredients', name: 'INGREDIENTS'}
    ];
    $scope.facets = [];
    $scope.facet = {
        app_id: appId,
        type: $scope.typeOptions[0].value,
        group: $scope.groupOptions[0].value
    };
    if ($scope.editMode) {
        Facets.get($stateParams.facetId, appId).then(function (response) {
            const data = response.data || response;
            if (data.success) {
                $scope.facet = data.facet;
                $scope.headerTitle.push('-');
                $scope.headerTitle.push(' ');
                $scope.headerTitle.push($scope.facet.name);
                $scope.facet.parent = data.facet.parent === 0 ? null : data.facet.parent;
            } else {
                growl.error('MODULES.FACETS.ERROR.GET_DATA');
                $state.go('appsoup.application.facets', {application_id: appId});
            }
        }).catch(function () {
            $state.go('appsoup.application.facets', {application_id: appId});
            growl.error('ERROR.EMPTY_DATA');
        }).finally(function () {
            $rootScope.doingResolve = false;
            $scope.facetLoaded = true;
            $scope.searchFacets('');
        });
    } else {
        $scope.facetLoaded = true;
    }

    $scope.searchFacets = function (text) {
        text = $filter('removeSpecial')(text);

        if ($scope.facetLoaded) {
            const facetId = $scope.editMode ? $scope.facet.id : 0;
            Facets.searchFacets(appId, facetId, text, $scope.facet.group).then(function (response) {
                const data = response.data || response;
                if (data.success) {
                    $scope.facets = data.facets;
                } else {
                    growl.error('MODULES.FACETS.ERROR.GET_DATA');
                }
            });
        }
    };

    $scope.replaceChars = function (text) {
        const dict = {'ą': 'a', 'ę': 'e', 'ć': 'c', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ż': 'z', 'ź': 'z'};
        let str = angular.copy(text);
        str = str.replace(/\s+/g, '-').toLowerCase();
        str = str.replace(/[^\w ]/g, function (char) {
            return dict[char] || char;
        });
        str = str.replace(/[^0-9a-z-_]+/g, '');
        str = str.replace(/[-]+/g, '-');
        str = str.replace(/[_]+/g, '_');

        return str;
    };

    $scope.generateLink = function () {
        if ($scope.facet.name) {
            $scope.facet.slug = $scope.replaceChars($scope.facet.name);
        }
    };

    $scope.$watch('facet.slug', function (oldValue, newValue) {
        if ($scope.facet.slug) {
            if (oldValue !== newValue) {
                let str = $scope.replaceChars($scope.facet.slug);
                str = str.replace(/[,]+/g, ',');
                str = str.replace(/[!]+/g, '!');
                $scope.facet.slug = str;
            }
        }
    });

    $scope.save = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        $scope.facet.parent = $scope.facet.parent === null ? 0 : $scope.facet.parent;
        Facets.save($scope.facet, $scope.editMode).then(function (response) {
            const data = response.data || response;
            if (data.success) {
                growl.success('MODULES.FACETS.SUCCESS.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                $state.go('appsoup.application.facets', {application_id: appId});
            } else {
                if (typeof data.errors === 'object') {
                    $scope.formErrors = data.errors.facet;
                } else {
                    growl.error('MODULES.FACETS.ERROR.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                }
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.facets', {application_id: appId});
    };

    $scope.onChangeGroup = function () {
        $scope.facet.parent = null;
        $scope.searchFacets('');
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'slug': [{error: 'pattern', msg: 'FORM.ERRORS.FORMAT'}, {error: 'required', msg: 'FORM.ERRORS.REQUIRED'}],
        'type': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'group': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'parent': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}]
    };
}]);

export default facetsControllers;
